import React from "react";
import styled from "@emotion/styled";

import {
  Button,
  CardActions,
  CardContent,
  Grid,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardHeader as MuiCardHeader,
  Divider as MuiDivider,
  Typography,
} from "@mui/material";
import { StarBorder as StarIcon } from "@mui/icons-material";
import { spacing } from "@mui/system";
import { useTranslation } from "react-i18next";

const Card = styled(MuiCard)(spacing);

const CardHeader = styled(MuiCardHeader)(spacing);

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Price = styled.div`
  text-align: center;
  padding-bottom: ${(props) => props.theme.spacing(3)};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: baseline;
  gap: ${(props) => props.theme.spacing(1)};
`;

const Header = styled.div`
  padding: ${(props) => props.theme.spacing(6)} 0;
`;

const PricingWrapper = styled.div`
  padding: 18px 20px;
`;

function Pricing() {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <PricingWrapper>
        <Header>
          <Typography variant="h3" gutterBottom align="center">
            We have a plan for everyone
          </Typography>

          <Typography variant="subtitle1" gutterBottom align="center">
            Whether you're a business or an individual, 14-day trial no credit
            card required.
          </Typography>
        </Header>

        <Grid container justifyContent="center">
          <Grid
            size={{ xs: 12, lg: 10 }}
            display="flex"
            flexDirection="column"
            gap={6}
          >
            <Grid container spacing={6} alignItems="flex-end">
              <Grid size={{ xs: 12, md: 4 }}>
                <Card p={5}>
                  <CardHeader
                    title="Brons"
                    pb={0}
                    pt={2}
                    slotProps={{
                      title: {
                        sx: {
                          textAlign: "center",
                        },
                      },
                      subheader: {
                        sx: {
                          textAlign: "center",
                        },
                      },
                    }}
                  />
                  <CardContent>
                    <Price>
                      <Typography
                        component="h2"
                        variant="h1"
                        color="textPrimary"
                        align="center"
                        display="inline"
                      >
                        €48
                      </Typography>
                      <Typography
                        variant="h5"
                        color="textSecondary"
                        align="center"
                        display="inline"
                      >
                        {t("plans.month")}
                      </Typography>
                    </Price>
                    <Typography variant="subtitle1" align="center">
                      <div>
                        Voor ZZP’ers en kleine teams (1 tot 5 gebruikers)
                        <br />
                        Uitgebreide AI analyse (risico’s, deadlines)
                        <br />
                        Tot 200 contracten
                        <br />
                        Betaalbare oplossing
                      </div>
                      Ideaal voor starters met contractmanagement
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      href="https://gobeyondprocurement.outseta.com/auth?widgetMode=register&planUid=rm0y6jQX&planPaymentTerm=month&skipPlanOptions=true"
                      fullWidth
                      variant="outlined"
                      color="primary"
                    >
                      {t("Sign up")}
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <Card p={5}>
                  <CardHeader
                    title="Zilver"
                    subheader="Most popular"
                    action={<StarIcon />}
                    pb={0}
                    pt={2}
                    slotProps={{
                      title: {
                        sx: {
                          textAlign: "center",
                        },
                      },
                      subheader: {
                        sx: {
                          textAlign: "center",
                        },
                      },
                    }}
                  />
                  <CardContent>
                    <Price>
                      <Typography
                        component="h2"
                        variant="h1"
                        color="textPrimary"
                        align="center"
                        display="inline"
                      >
                        €89
                      </Typography>
                      <Typography
                        variant="h5"
                        color="textSecondary"
                        align="center"
                        display="inline"
                      >
                        {t("plans.month")}
                      </Typography>
                    </Price>
                    <Typography variant="subtitle1" align="center">
                      <div>
                        Voor middelgrote teams (5 tot 20 gebruikers)
                        <br />
                        Uitgebreide AI analyse (aansprakelijkheid, indexaties)
                        <br />
                        Tot 1000 contracten
                        <br />
                        Integratie met MS365 (SharePoint, OneDrive, Teams)
                      </div>
                      Meest gekozen voor groeiende organisaties
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      href="https://gobeyondprocurement.outseta.com/auth?widgetMode=register&planUid=1QpG5gmE&planPaymentTerm=month&skipPlanOptions=true"
                      fullWidth
                      variant="contained"
                      color="primary"
                    >
                      {t("Sign up")}
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <Card p={5}>
                  <CardHeader
                    title="Goud"
                    pb={0}
                    pt={2}
                    slotProps={{
                      title: {
                        sx: {
                          textAlign: "center",
                        },
                      },
                      subheader: {
                        sx: {
                          textAlign: "center",
                        },
                      },
                    }}
                  />
                  <CardContent>
                    <Price>
                      <Typography
                        component="h2"
                        variant="h1"
                        color="textPrimary"
                        align="center"
                        display="inline"
                      >
                        €149
                      </Typography>
                      <Typography
                        variant="h5"
                        color="textSecondary"
                        align="center"
                        display="inline"
                      >
                        {t("plans.month")}
                      </Typography>
                    </Price>
                    <Typography variant="subtitle1" align="center">
                      <div>
                        Voor grote teams (20+ gebruikers) <br />
                        Maatwerk AI analyse & rapportages <br />
                        Tot 5000 contracten <br />
                        Integratie met MS365 & ERP
                      </div>
                      Volledige support en SLA Voor maximale grip en
                      schaalbaarheid
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      href="https://gobeyondprocurement.outseta.com/auth?widgetMode=register&planUid=amRjXdmJ&planPaymentTerm=month&skipPlanOptions=true"
                      fullWidth
                      variant="outlined"
                      color="primary"
                    >
                      {t("Sign up")}
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <Card p={5}>
                <CardHeader
                  title={t("plans.exploreMode")}
                  subheader={t("plans.exploreModeDescription")}
                  pb={0}
                />
                <CardActions>
                  <div>
                    <Button
                      href="https://gobeyondprocurement.outseta.com/auth?widgetMode=register&planUid=pWrY809n&planPaymentTerm=month&skipPlanOptions=true"
                      fullWidth
                      variant="outlined"
                      color="primary"
                    >
                      {t("plans.exploreModeButton")}
                    </Button>
                  </div>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </PricingWrapper>
    </React.Fragment>
  );
}

export default Pricing;
